<template>
  <div>
    <v-layout row wrap class="ma-0 pa-0">
      <v-flex xs12 sm6 style="border-right: 1px solid #eee">
        <div style="position: relative">
          <v-btn
            style="z-index: 3; position: absolute; right: 0px; top: 0px"
            small
            @click="showImage(input.identityNumberImage)"
          >
            <v-icon>visibility</v-icon>
          </v-btn>
          <uploadfile :height="500" v-model="input.identityNumberImage"></uploadfile>
        </div>
        <!-- <v-img
         
          contain
          height="500px"
          :src="editdata.identity_number_image"
        ></v-img> -->
      </v-flex>
      <v-flex xs12 sm6>
        <div class="px-4 pb-3">
          <v-btn style="float: right" @click="$emit('close')" icon>
            <v-icon>close</v-icon>
          </v-btn>

          <div style="font-size: 20px; font-weight: 600" class="pt-3 mb-3">แก้ไขข้อมูล</div>
          <div class="form-control">
            <v-layout class="pa-0 ma-0" wrap row>
              <v-flex
                xs12
                sm6
                class="form-control pa-1"
                :class="{ 'has-error': errors.has('firstName') }"
              >
                <label>{{ $t('ชื่อจริง') }}</label>
                <input
                  :data-vv-as="$t('ชื่อจริง')"
                  v-validate="'required'"
                  v-model="input.firstName"
                  class="form-control"
                  type="text"
                  name="firstName"
                />
                <span class="text-error" v-if="errors.has('firstName')">{{
                  errors.first('firstName')
                }}</span>
              </v-flex>
              <v-flex
                xs12
                sm6
                class="form-control pa-1"
                :class="{ 'has-error': errors.has('lastName') }"
              >
                <label>{{ $t('นามสกุล') }}</label>
                <input
                  :readonly="edittype == 'edit'"
                  :data-vv-as="$t('นามสกุล')"
                  v-validate="'required'"
                  v-model="input.lastName"
                  class="form-control"
                  type="text"
                  name="lastName"
                />
                <span class="text-error" v-if="errors.has('lastName')">{{
                  errors.first('lastName')
                }}</span>
              </v-flex>
              <v-flex xs6 sm6 class="form-control pa-1" :class="{ 'has-error': errors.has('dob') }">
                <label>{{ $t('วันเดือนปี เกิด') }}</label>
                <DatePickerWithoutButton v-model="input.dob">
                  <input
                    readonly
                    :data-vv-as="$t('วันเดือนปี เกิด')"
                    v-validate="'required'"
                    :value="getdate(input.dob)"
                    class="form-control"
                    type="text"
                    name="dob"
                  />
                </DatePickerWithoutButton>
                <span class="text-error" v-if="errors.has('dob')">{{ errors.first('dob') }}</span>
              </v-flex>
              <v-flex xs6 sm6 class="form-control pa-1" :class="{ 'has-error': errors.has('job') }">
                <label>{{ $t('อาชีพ') }}</label>
                <input
                  :data-vv-as="$t('อาชีพ')"
                  v-validate="'required'"
                  v-model="input.job"
                  class="form-control"
                  type="text"
                  name="job"
                />
                <span class="text-error" v-if="errors.has('job')">{{ errors.first('job') }}</span>
              </v-flex>
              <v-flex
                xs6
                sm6
                class="form-control pa-1"
                :class="{ 'has-error': errors.has('identityNumber') }"
              >
                <label>{{ $t('เลขบัตรประชาชน') }}</label>
                <input
                  readonly
                  :data-vv-as="$t('เลขบัตรประชาชน')"
                  v-validate="'required'"
                  v-model="input.identityNumber"
                  class="form-control"
                  type="text"
                  name="identityNumber"
                />
                <span class="text-error" v-if="errors.has('identityNumber')">{{
                  errors.first('identityNumber')
                }}</span>
              </v-flex>
              <v-flex
                xs6
                sm6
                class="form-control pa-1"
                :class="{ 'has-error': errors.has('lineName') }"
              >
                <label>{{ $t('ไลน์') }}</label>
                <input
                  readonly
                  :data-vv-as="$t('ไลน์')"
                  v-validate="'required'"
                  v-model="input.lineName"
                  class="form-control"
                  type="text"
                  name="lineName"
                />
                <span class="text-error" v-if="errors.has('lineName')">{{
                  errors.first('lineName')
                }}</span>
              </v-flex>
              <v-flex xs12>
                <div>
                  <v-checkbox v-model="member_status" :label="`Approve`"></v-checkbox>
                </div>
              </v-flex>
            </v-layout>
            <div class="text-xs-center">
              <v-btn @click="$emit('close')" outline color="grey">cancel</v-btn>
              <v-btn :loading="saveloading" @click="editmember" depressed color="primary"
                >save</v-btn
              >
            </div>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import moment from 'moment'
import PhotoViewer from 'photoviewer'
import uploadfile from '@/components/elements/uploadfile.vue'

export default {
  props: ['edittype', 'editdata'],
  components: { DatePickerWithoutButton, uploadfile },
  data() {
    return {
      saveloading: false,
      input: {
        firstName: '',
        lastName: '',
        dob: '',
        job: '',
        identityNumber: '',
        identityNumberImage: '',
        lineName: ''
      },
      member_status: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    this.$set(this, 'input', {
      firstName: this.editdata.first_name,
      lastName: this.editdata.last_name,
      dob: this.editdata.dob,
      job: this.editdata.job,
      identityNumber: this.editdata.identity_number,
      identityNumberImage: this.editdata.identity_number_image,
      lineName: this.editdata.linename
      // member_status: this.editdata.member_status,
    })
    this.$nextTick(() => {
      this.member_status = this.editdata.member_status === 'true' ? true : false
    })
    this.$forceUpdate()

    // }
  },
  methods: {
    showImage(item) {
      var items = [
        {
          src: item,
          title: `${item}`
        }
      ]

      // define options (if needed)
      var options = {
        fixedContent: false,
        fixedModalPos: true,
        index: 0 // this option means you will start at first image
      }

      // Initialize the plugin
      var viewer = new PhotoViewer(items, options)
      document.querySelector('.photoviewer-modal').addEventListener(
        'click',
        function (event) {
          //  document.getElementById("output-box").innerHTML += "Sorry! <code>preventDefault()</code> won't let you check this!<br>";
          event.preventDefault()
        },
        false
      )
    },
    getdate(date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY')
      } else {
        return ''
      }
    },
    // async savedata() {
    //   if (await this.$validator.validateAll()) {
    //     if (this.edittype == 'create') {
    //       this.createdata()
    //     } else {
    //       this.editbranch()
    //     }
    //   }
    // },
    async editmember() {
      if (await this.$validator.validateAll()) {
        var data = {
          memberId: this.editdata.id,
          pageid: this.selectedBot.pageid,
          ...this.input
        }
        this.saveloading = true
        api.editmembertoacrm(data, async (err, response) => {
          api.editToacrmMemberStatus(
            {
              data: { member_status: this.member_status ? true : false },
              params: {
                id: this.editdata.id,
                pageid: this.selectedBot.pageid
              }
            },
            (err, response2) => {
              this.saveloading = false
              if (response2.responsecode == 200) {
                this.$emit('onsave')
              }
            }
          )
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/MemberEdit.vue